import { NotificationProvider } from "@smoothincorg/smooth-ui"
import { AppProps } from "next/app"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { RecoilRoot } from "recoil"
import { AuthProvider } from "src/features/auth"
import "src/lib/styles/global.scss"
import { GetTokenFromCookies } from "src/lib/utils/cookies"
import { AppStateProvider } from "src/store/AppStateContext"
import { SidebarProvider } from "src/store/SidebarContext"
import { SWRConfig } from "swr"

const App = ({ Component, pageProps }: AppProps) => {
  const router = useRouter()
  const pathname = router.pathname

  useEffect(() => {
    const token = GetTokenFromCookies()
    if (!token && pathname !== "/admin/sign-in") {
      router.replace(
        "/admin/sign-in?" +
          new URLSearchParams({
            "signed-out": "1",
            "redirect-to": pathname,
          })
      )
    }
  }, [router, pathname])

  return (
    <AppStateProvider>
      <SWRConfig
        value={{
          revalidateIfStale: false,
          revalidateOnFocus: false,
          revalidateOnReconnect: false,
        }}
      >
        <AuthProvider>
          <RecoilRoot>
            <SidebarProvider>
              <NotificationProvider>
                <Component {...pageProps} />
              </NotificationProvider>
            </SidebarProvider>
          </RecoilRoot>
        </AuthProvider>
      </SWRConfig>
    </AppStateProvider>
  )
}

export default App
